export const HUB_NAMES = {
    MANAGEMENT_POLICY_RULES_CREATION: "ManagementPolicyRulesCreation",
    MAILBOXES_HANDLING: "MailboxesHandling",
    STUDIO_HANDLING: "StudioHandling",
};

export const METHOD_NAMES = {
    DEFAULT: "newMessage",
};

export interface ConnectionInfo {
    accessToken: string;
    url: string;
}
